import Cookies from "js-cookie";
import moment from "moment/moment";
import ApiCall from "../Api/ApiCall";
import { AuthEndPoints, AwsS3Routes } from "../Api/Endpoints";
import { ToasterMessage } from "./toasterMessage";
import toast from "react-hot-toast";
import MainRoutes from "../Navigation/MainRoutes";
import { clearReduxState } from "./clearReduxState";

//******* START API CALL ********/
export const startApiCall = (seterrorMessage, setLoader) => {
  {
    seterrorMessage !== null && seterrorMessage("");
  }
  setLoader(true);
  setTimeout(() => {
    setLoader(false);
  }, 50000);
};

//** USER LOGOUT */
export const userLogout = async () => {
  toast.loading(ToasterMessage.Logout);
  const fcmToken = localStorage.getItem("fcmToken");
  let res;
  if (fcmToken) {
    res = await ApiCall("get", AuthEndPoints.logout, { params: { fcmToken } });
  } else {
    res = await ApiCall("get", AuthEndPoints.logout);
  }
  if (res.success) {
    await clearReduxState();
    Cookies.remove("isLoggedIn");
    localStorage.clear();
    window.location.href = MainRoutes.HOME;
  }
};

//** CHECK IF USER IS S2 ADMIN */
export const isS2Admin = (user) => {
  return user?.registerFor === "s2admin";
};

//** FORMAT TIME */
export const formatTime = (date) => {
  const timeString = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  const dateString = date.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return `${timeString}, ${dateString}`;
};

//********* DATE FORMATER ***********/
export const dateFormatter = (date) => {
  return moment(new Date(date)).format("DD/MM/YYYY");
};
//** DATE TIME FORMATER */
export const dateTimeFormatter = (date) => {
  return moment(new Date(date)).format("DD/MM/YYYY - hh:mm:ss A");
};

export const dateTimeFormatterForMis = (date) => {
  return moment(new Date(date)).format("DD MMM YYYY  HH:mm:ss ");
};
//** COPY TO CLIPBOARD */
export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
  toast.success(ToasterMessage.Copied);
};

//** SORT DATA */
export const handleSortData = (data, sortBy, sortOrder) => {
  return data.sort((a, b) => {
    const dateA = new Date(a[sortBy]);
    const dateB = new Date(b[sortBy]);
    return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
  });
};

//** GET LEVELWISE DATA */
export const getLevelwiseData = (
  levelGroups,
  { levelId = null, levelNumber = null }
) => {
  for (const group of levelGroups) {
    for (const level of group) {
      if (
        (levelId && level.levelId === levelId) ||
        (levelNumber && level.levelNumber === levelNumber)
      ) {
        return level;
      }
    }
  }
  return null; // Not found
};

//** GET AUTO SELECTED LEVEL DATA */
export const getLevelDataDetails = (itemLevelData, levelId) => {
  if (!itemLevelData || !levelId) return null;
  const filteredItemLevelData = itemLevelData.filter(
    (item) => item?.levelId === levelId
  );
  return filteredItemLevelData.length > 0 ? filteredItemLevelData?.[0] : null;
};

// Remove space
export const removeSpace = (str) => str.trim();

// Convert text to lowercase and replace spaces with underscores
export function toLowerUnderscore(text) {
  return text.trim().toLowerCase().replace(/\s+/g, "_");
}

//  **  FORMATED INPUT STRING
export const formatInputString = (input) => {
  // Remove non-alphabetic characters except underscore and space
  // const cleaned = input?.replace(/[^a-zA-Z_ ]/g, "");
  // Split by underscores or spaces, filter empty strings
  const words = input?.split(/[_ ]+/)?.filter(Boolean);

  // Capitalize each word and join them with spaces
  const formatted = words
    ?.map(
      (word) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
    )
    ?.join(" ");

  return formatted;
};

/*********  GET MONTHS ***********/

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

//**Get start Date and End date of the current month */

export const getFirstAndLastDateOfMonth = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();

  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  return {
    firstDay: firstDay.toISOString().split("T")[0],
    lastDay: lastDay.toISOString().split("T")[0],
  };
};

//*** Change text to camel case */
export function toCamelCase(str) {
  if (!str) return "";

  return str
    .toLowerCase()
    .replace(/[\u200B-\u200D\uFEFF]/g, "") // Remove invisible unicode characters
    .trim()
    .replace(/[^a-zA-Z0-9 ]/g, "") // Optional: Remove special characters
    .split(" ")
    .filter(Boolean)
    .map((word, index) =>
      index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join("");
}

//*** Is Any Key Match */
export const isAnyKeyMatch = (array, key) => {
  return Array.isArray(array)
    ? array.some((item) => item?.[key] === true)
    : false;
};

//**** Get Deadline */

export const getTotalDeadlineInHours = (levelDataArray) => {
  if (!Array?.isArray(levelDataArray)) return 0;

  return levelDataArray?.reduce((total, item) => {
    const deadline = Number(item?.deadline);
    return !isNaN(deadline) ? total + deadline : total;
  }, 0);
};

//***Convert To Lowercase  */
export function toLowerCase(input) {
  return input.replace(/\s+/g, "").toLowerCase();
}

//*** Split Camel Case */
export const splitCamelCase = (str) => {
  return str?.replace(/([a-z])([A-Z])/g, "$1 $2");
};

//**Preview Image in Local */
export const handlePreviewFileInLocal = (fileOrEvent) => {
  if (fileOrEvent instanceof File) {
    return URL.createObjectURL(fileOrEvent);
  }

  if (fileOrEvent?.target?.files && fileOrEvent.target.files.length > 0) {
    return URL.createObjectURL(fileOrEvent.target.files[0]);
  }

  return null;
};

// Updated Image Function
export const handleGeneratePreSignedURLAWSS3 = async (image) => {
  const timestamp = new Date().toISOString();
  const uniqueFileName = `${image?.name?.replace(
    /\.[^/.]+$/,
    ""
  )}_${timestamp}${image?.name?.match(/\.[^/.]+$/)}`;

  let params = new URLSearchParams({
    fileType: image?.type,
    fileName: uniqueFileName,
  });
  let res = await ApiCall(
    "get",
    `${AwsS3Routes.getPreSignedURL}?${params.toString()}`
  );
  return res?.result || null;
};

export const handleUploadImgFile = async (file) => {
  try {
    let mainFile;

    if (file instanceof File) {
      mainFile = file;
    } else if (file?.target?.files?.[0]) {
      mainFile = file.target.files[0];
    } else {
      console.error("Invalid file input");
      return null;
    }
    const { presignedUrl, fileUrl } = await handleGeneratePreSignedURLAWSS3(
      mainFile
    );
    const uploadResponse = await fetch(presignedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": mainFile.type,
      },
      body: mainFile,
    });

    if (uploadResponse.ok) {
      return fileUrl;
    } else {
      console.error(
        "File upload failed:",
        uploadResponse.status,
        uploadResponse.statusText
      );
      return null;
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    return null;
  }
};

export const getActionByUserAccessForLogs = (isS2Admin,actionByUserAccessId,actionOnUserAccessId,isChangeAddress = false) => {
  if(isChangeAddress){
    return {
      actionByUserAccess: isS2Admin ? null : actionByUserAccessId,  
      actionOnUserAccess:  actionOnUserAccessId,
    };
  }
  let data = {
    actionByUserAccess: isS2Admin ? null : actionByUserAccessId,  
    actionOnUserAccess: isS2Admin ? null : actionOnUserAccessId,
  };
  return data;
};

export const getMonthRange = (startDate, endDate) => {
  // The function returns an array of month-year strings in "MM-YYYY" format between startDate and endDate (inclusive)
  const monthRange = [];
  const start = moment(startDate, ["DD/MM/YYYY", "YYYY-MM-DD", "MM/DD/YYYY"]);
  const end = moment(endDate, ["DD/MM/YYYY", "YYYY-MM-DD", "MM/DD/YYYY"]);
  if (!start.isValid() || !end.isValid()) return monthRange;
  let current = start.clone();
  while (current.isSameOrBefore(end, "month")) {
    monthRange.push(current.format("MM-YYYY"));
    current.add(1, "month");
  }
  return monthRange;
  
};


export const getMonthName = (startDate) => {
  const start = moment(startDate, ["DD/MM/YYYY", "YYYY-MM-DD", "MM/DD/YYYY"]);
  return start.format("MMM ")+(start.year());
};


export const perCentageColor = (percentage) => {
  if (percentage >= 0 && percentage <= 50) {
    return "text-danger";
  } else {
    return "text-success";
  }
};

export const checkDeadlineExceeded = (finalDeadline) => {
  const currentTime = moment();
  const finalDeadlineTime = moment(finalDeadline);
  return finalDeadlineTime.isBefore(currentTime);
};
